import { apiSlice } from "../../app/api/apiSlice";
import { ApiResponse, TourObj } from "../../shared/types";

export const toursApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getTours: builder.query<ApiResponse<TourObj[]>, string>({
            query: (searchParams: string) => ({
                url: `/api/v1/tours?${searchParams}`,
            }),
            keepUnusedDataFor: 10,
            providesTags: (result) =>
                result?.data?.data
                    ? [
                          { type: "Tour" as const, id: "LIST" },
                          ...result.data.data.map((tour) => ({
                              type: "Tour" as const,
                              id: tour._id,
                          })),
                      ]
                    : [{ type: "Tour" as const, id: "LIST" }],
        }),
        getTour: builder.query<ApiResponse<TourObj>, string>({
            query: (id: string) => ({ url: `/api/v1/tours/${id}` }),
            keepUnusedDataFor: 10,
            providesTags: (result, error, id) => [{ type: "Tour" as const, id }],
        }),
    }),
})

export const {
    useGetToursQuery,
    useGetTourQuery,
} = toursApiSlice
